import PropTypes from 'prop-types';
import React from 'react';

import Drawer from '@commons/Drawer';
import HistoryDrawerContent from '@commons/HistoryDrawer/HistoryDrawerContent';

const AuditHistoryDrawer = ({ auditLogs, subtitle, isOpened, onClose }) => (
  <Drawer isOpened={isOpened} overlayOpacity="none" onClick={onClose}>
    <HistoryDrawerContent auditLogs={auditLogs} subtitle={subtitle} onClose={onClose} />
  </Drawer>
);

AuditHistoryDrawer.propTypes = {
  auditLogs: PropTypes.arrayOf(PropTypes.object),
  subtitle: PropTypes.string,
  isOpened: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
};

AuditHistoryDrawer.defaultProps = {
  auditLogs: [],
  subtitle: '',
  isOpened: false,
};

export default AuditHistoryDrawer;
